import * as Scrivito from "scrivito";
import I18n from "^/config/i18n";

const EasyLanguageButton = ({ easyLanguagePageLink }) => {
  if (!easyLanguagePageLink) {
    return <div />;
  }
  return (
    <Scrivito.LinkTag
      to={easyLanguagePageLink}
      title={I18n.t("Easy language button")}
      className="d-inline-block"
    >
      <i className="las la-book-reader nav-icon" />
    </Scrivito.LinkTag>
  );
};

export default Scrivito.connect(EasyLanguageButton);
